import { observable } from "mobx";
import { Type } from "class-transformer";
import ExternalReportDownloadResponse from "./externalReportDownloadResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class GetExternalReportDetailResponse {
  id!: string;

  @observable
  reportName!: string;

  @observable
  createdBy!: string;

  @observable
  @Type(() => ExternalReportDownloadResponse)
  downloads!: ExternalReportDownloadResponse[];
}
